import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Collapse,
  Row,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import NumberFormat from "react-number-format";
import Select from "react-select";
import tooltipText from "./../../../../../views/Forms/ShortCutComponents/tooltipText";
import { CheckClosingYearD } from "../../../ShortFunction/CheckClosingYearD";
import moment from "moment";
import AddPartyType from "../../PartyType/components/addPartyType";
import AddSociety from "../../Society/components/addSociety";
import AddSector from "../../Sector/components/addSector";
import AddPartyModel from "../../../RealEstate/Party/PartyForm/PartyForm";
import { Modal } from "react-bootstrap";
import { checkPermission } from "../../../../../Helper";
import "../myReactSelect.css";
import swal from "@sweetalert/with-react";
import { AppSwitch } from "@coreui/react";
import { baseurl } from "./../../../../../baseurl";
import { Link } from "react-router-dom";
import axios from "axios";
import { GetIp } from "./../../../../../views/Forms/ShortCutComponents/Get_ip";
import ReactDatePicker from "./../../../../../views/Forms/ShortCutComponents/ReactDatePicker";
import ResponseLoader from "./../../../../../views/Forms/ShortCutComponents/ResponseLoader";
import { dynamicCurrencyFormator } from "./../../../../../utils/functions";
// import PropFeature from "./PropFeaturesModel";
import PropFeature from "../../DealForm/PropFeaturesModel";

const username = localStorage.getItem("username");
const token = localStorage.getItem("token");
const companyId = localStorage.getItem("companyId");

export default function DealForm(props) {
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [disabledState, setDisabledState] = useState(false);
  const [propTypLov, setPropTypLov] = useState([]);
  const [propSizeLov, setPropSizeLov] = useState([]);
  const [sectorLov, setSectorLov] = useState([]);
  const [partyLov, setPartyLov] = useState([]);
  const [termsTypeLov, setTermsTypeLov] = useState([]);
  const [periodsLov, setPeriodsLov] = useState([]);
  const [societyLov, setSocietyLov] = useState([]);
  const [categoryLov, setCategoryLov] = useState([]);
  const [ipCountry, setIpCountry] = useState(false);

  //add party form
  const [showFormOnBtn, setShowFormOnBtn] = useState(false);

  // ye state detail form kcolapse ko handle kr rhi hr
  const [divcontainer, setDivcontainer] = useState(true);
  const [divcontainer2, setDivcontainer2] = useState(true);
  const [divcontainer3, setDivcontainer3] = useState(true);
  // ye state LOV k check ko handle kr rhi he
  const [requiredCheck, setRequiredCheck] = useState(false);

  const [masterData, setMasterData] = useState({
    dealNo: null,
    dealDate: new Date(),
    partyName: "",
    isOpenPartyModel: false,
    dealDescription: "",
    societyId: "",
    sectorId: "",
    ownerName: "",
    ownerAddress: "",
    ownerPhone: null,
    ownerNic: null,
    buyerName: "",
    buyerAddress: "",
    buyerPhone: null,
    buyerNic: null,
    typeId: null,
    categoryId: null,
    sizeId: null,
    remarks: null,
    propNo: null,
    amount: 0,
    isOpenPropModel: false,
    checkboxes: [],
    remarks: "",
  });
  const [totalValues, setTotalValues] = useState({
    totalComPrice: 0,
    totalCommission: 0,
    totalCost: 0,
  });

  const [data, setData] = useState({
    formValues: [
      {
        lineNum: 1,
        commissionPayParty: null,
        commissionPayAmount: 0,
        commissionPayPersent: null,
        commissionPayRemarks: "",
      },
    ],
  });
  const [terms, setTerms] = useState({
    formValues: [
      {
        lineNum: 1,
        termsType: null,
        termsAmount: null,
        termsPersent: null,
        termsPeriod: null,
        termsNo: null,
        termsRemarks: "",
      },
    ],
  });

  const [commRecDetailArray, setCommRecDetailArray] = useState({
    formValues: [
      {
        lineNum: 1,
        commissionParty: null,
        commissionAmount: 0,
        commissionPersent: null,
        commissionRemarks: "",
      },
    ],
  });

  const stringToNumber = (str) => {
    let newValue = 0;
    if (str) {
      newValue = Number(str?.toString()?.replaceAll(",", ""));
    }

    return newValue;
  };
  const convertToYmdDateFormart = (propDate, useNewDate) => {
    let newDate = null;
    let propDateParam = propDate === "0000-00-00" ? null : propDate;
    if (propDateParam) {
      if (useNewDate) {
        newDate = new Date(propDateParam);
      } else {
        newDate = moment(propDateParam).format("YYYY-MM-DD");
      }
    }
    return newDate;
  };
  const itemLoad = () => {
    setShowFormOnBtn({
      // row_id: "-1",
      showFormOnBtn: !showFormOnBtn,
    });
    // this.getData();
  };
  const reCalculate = (formValues) => {
    let totalComPrice = 0;
    let totalCommission = 0;
    let totalCost = 0;
    for (let loop = 0; loop < formValues.length; loop++) {
      const element = formValues[loop];
      totalComPrice += stringToNumber(element.companyPrice);
      totalCommission += stringToNumber(element.commission);
      totalCost += stringToNumber(element.totalCost);
    }
    setTotalValues({
      ...totalValues,
      totalComPrice,
      totalCommission,
      totalCost,
    });
  };
  const showProp = () => {
    addPropToggle();
  };
  const addPropToggle = () => {
    setMasterData({
      ...masterData,
      isOpenPropModel: !masterData.isOpenPropModel,
    });
  };
  const emptycommission = () => {
    let formValues = data.formValues;

    let totalCost = 0;
    for (let index = 0; index < formValues.length; index++) {
      const element = formValues[index];
      let commission = element.commission;
      element.totalCost =
        stringToNumber(element.totalCost) - stringToNumber(commission);
      element.commission = 0;
      totalCost += stringToNumber(element.totalCost);
    }

    setData({
      ...data,
      formValues,
    });
    setTotalValues({
      ...totalValues,
      totalCommission: 0,
      totalCost,
    });
  };
  const checkNullObject = (objId, objLabel) => {
    return objId ? { id: objId, label: objLabel } : null;
  };
  const removeFormFieldsItem = (i) => {
    let formValues = data.formValues;

    if (formValues.length > 1) {
      formValues.splice(i, 1);
      reCalculate(formValues);
    } else {
      swal({
        title: "Invalid!",
        text: "Atleast 1 row should be selected!",
        icon: "error",
      });
      setData({
        ...data,
        formValues: [
          {
            commissionPayParty: null,
            commissionPayAmount: 0,
            commissionPayPersent: 0,
            commissionPayRemarks: "",
          },
        ],
      });
    }
  };
  const removeItemFormFields = (i) => {
    let formValues = terms.formValues;

    if (formValues.length > 1) {
      formValues.splice(i, 1);
      // reCalculate(formValues);
    } else {
      swal({
        title: "Invalid!",
        text: "Atleast 1 row should be selected!",
        icon: "error",
      });
      setTerms({
        ...terms,
        formValues: [
          {
            termsType: null,
            termsAmount: null,
            termsPersent: null,
            termsPeriod: null,
            termsNo: null,
            termsRemarks: "",
          },
        ],
      });
    }
  };
  const removeFormFieldsItem2 = (i) => {
    let formValues = commRecDetailArray.formValues;
    let dynamicMsg = "Your Commission data is completely removed!";

    if (formValues.length > 1) {
      formValues.splice(i, 1);

      setCommRecDetailArray({
        ...commRecDetailArray,
        formValues,
      });
    } else {
      formValues[0]["partner"] = null;
      formValues[0]["lineNum"] = 1;
      formValues[0]["percentage"] = 0;
      formValues[0]["pRemarks"] = "";

      // setCommRecDetailArray({ ...commRecDetailArray, formValues });
      swal({
        title: "No Commission!",
        text: dynamicMsg,
        icon: "warning",
      });
      setCommRecDetailArray({
        ...commRecDetailArray,
        formValues: [
          {
            commissionParty: null,
            commissionAmount: 0,
            commissionPersent: null,
            commissionRemarks: "",
          },
        ],
      });
    }
  };
  const addTermsFormFields = () => {
    let lineNumber = terms.formValues.length + 1;
    console.log("lineNumber--------------", lineNumber);

    setTerms({
      formValues: [
        ...terms.formValues,
        {
          partyLov: null,
          percentage: 0,
          pRemarks: "",

          lineNum: lineNumber,
        },
      ],
      show: false,
    });
  };
  const addFormFieldsItem2 = () => {
    let lineNumber = commRecDetailArray.formValues.length + 1;
    console.log("lineNumber=========", lineNumber);

    setCommRecDetailArray({
      formValues: [
        ...commRecDetailArray.formValues,
        {
          partyLov: null,
          percentage: 0,
          pRemarks: "",

          lineNum: lineNumber,
        },
      ],
      show: false,
    });
  };

  const goBackFun = () => {
    let pathName = props?.location?.state?.goBackUrl;
    this.props.history.push({
      pathname: "/DealPrint",
      state1: masterData,
      state2: data,
      // state3: totalValues,
    });
  };
  const addFormFieldsItem = (copyWithRecord, index) => {
    let lineNumber = data.formValues.length + 1;
    console.log("addddddddddd");
    let formValues;
    setData({
      formValues: [
        ...data.formValues,
        {
          lineNum: lineNumber,
          partyLov: null,
        },
      ],
      show: false,
    });

    // if (copyWithRecord) {
    //   let rowData = data.formValues[index];
    //   formValues = [
    //     ...data.formValues,
    //     {
    //       unitNo: rowData.unitNo,
    //       type: rowData.type,
    //       category: rowData.category,
    //       size: rowData.size,
    //       companyPrice: rowData.companyPrice,
    //       commission: rowData.commission,
    //       totalCost: rowData.totalCost,
    //       lineNum: lineNumber,
    //     },
    //   ];
    //   setData({
    //     formValues,
    //     show: false,
    //   });
    //   reCalculate(formValues);
    // } else {
    //   setData({
    //     formValues: [
    //       ...data.formValues,
    //       {
    //         lineNum: lineNumber,
    //         partyLov: null,
    //       },
    //     ],
    //     show: false,
    //   });
    // }
  };
  const masterInputEvent = (e, pName) => {
    if (pName === "partyName") {
      setMasterData({ ...masterData, partyName: e });
    } else if (pName === "societyId") {
      if (e?.id) {
        propSectLov(e.id);
        setMasterData({ ...masterData, societyId: e, sectorId: null });
      } else {
        setMasterData({ ...masterData, sectorId: null, societyId: null });
        setSectorLov({
          sectorOptions: [],
        });
      }
    } else if (pName === "sectorId") {
      setMasterData({ ...masterData, sectorId: e });
    } else if (pName === "type") {
      setMasterData({ ...masterData, typeId: e });
      console.log("======================", e);
    } else if (pName === "category") {
      setMasterData({ ...masterData, categoryId: e });
      console.log("======================", e);
    } else if (pName === "size") {
      setMasterData({ ...masterData, sizeId: e });
      console.log("======================", e);

      if (e === null) emptycommission();
    } else {
      const value = e.target.value;
      const name = e.target.name;

      setMasterData({ ...masterData, [name]: value });
      console.log("======================", name, value);
    }
  };
  const masterInputEvent2 = (index, e, pName) => {
    let formValues = commRecDetailArray.formValues;
    if (pName === "partner") {
      formValues[index][pName] = e;
      setCommRecDetailArray({
        ...commRecDetailArray,
        formValues,
      });
    } else if (e.target.name === "percentage") {
      formValues[index]["percentage"] = e.target.value;
      let totalPercentage = formValues.reduce(
        (acc, element) => acc + Number(element.percentage),
        0
      );

      if (Number(totalPercentage) <= 100) {
        formValues[index]["percentage"] = e.target.value;
        setCommRecDetailArray({
          ...commRecDetailArray,
          formValues,
        });
      } else {
        swal({
          title: "Invalid",
          text: "Percentage cannot be more than 100",
          icon: "warning",
        });
        formValues[index]["percentage"] = 0;
        setCommRecDetailArray({
          ...commRecDetailArray,
          formValues,
        });
      }
    } else if (e.target.name === "pRemarks") {
      formValues[index]["pRemarks"] = e.target.value;
      setCommRecDetailArray({
        ...commRecDetailArray,
        formValues,
      });
    }
  };
  const inputEvent = (e, index, pName) => {
    let formValues = data.formValues;

    if (pName) {
      console.log(e);
      if (pName === "commissionPayParty") {
        formValues[index]["commissionPayParty"] = e;
      }
    } else {
      const value = e.target.value;
      const name = e.target.name;
      console.log("--------------------=", name, value);
      // let totalnet = totalValues.totalCost?.toString()?.replaceAll(",", "");
      let totalnet = masterData.amount?.toString()?.replaceAll(",", "");
      totalnet = parseFloat(totalnet) > 0 ? parseFloat(totalnet) : 0;

      formValues[index][name] = value;

      if (name === "commissionPayAmount" && totalnet) {
        formValues[index]["commissionPayPersent"] = parseFloat(
          (parseFloat(
            formValues[index]["commissionPayAmount"]
              ?.toString()
              ?.replaceAll(",", "")
          ) /
            totalnet) *
            100
        );
      } else if (name === "commissionPayPersent" && totalnet) {
        formValues[index]["commissionPayAmount"] = parseFloat(
          (parseFloat(formValues[index]["commissionPayPersent"]) / 100) *
            totalnet
        );
      }
    }
    setData({
      ...data,
      formValues,
    });
  };
  const addPartyToggle = () => {
    setMasterData({
      ...masterData,
      isOpenPartyModel: !masterData.isOpenPartyModel,
    });
  };
  const inputEvent2 = (e, index, pName) => {
    let formValues = terms.formValues;

    if (pName) {
      console.log(e);
      if (pName === "termsType") {
        formValues[index]["termsType"] = e;
      } else if (pName === "termsPeriod") {
        formValues[index]["termsPeriod"] = e;
      }
    } else {
      const value = e.target.value;
      const name = e.target.name;
      console.log("--------------------=", name, value);
      // let totalnet = totalValues.totalCost?.toString()?.replaceAll(",", "");
      let totalnet = masterData.amount?.toString()?.replaceAll(",", "");
      totalnet = parseFloat(totalnet) > 0 ? parseFloat(totalnet) : 0;

      formValues[index][name] = value;

      if (name === "termsAmount" && totalnet) {
        formValues[index]["termsPersent"] = parseFloat(
          (parseFloat(
            formValues[index]["termsAmount"]?.toString()?.replaceAll(",", "")
          ) /
            totalnet) *
            100
        );
      } else if (name === "termsPersent" && totalnet) {
        formValues[index]["termsAmount"] = parseFloat(
          (parseFloat(formValues[index]["termsPersent"]) / 100) * totalnet
        );
      }
    }
    setTerms({
      ...terms,
      formValues,
    });
  };
  const inputEvent3 = (e, index, pName) => {
    let formValues = commRecDetailArray.formValues;

    if (pName) {
      console.log(e);
      if (pName === "commissionParty") {
        formValues[index]["commissionParty"] = e;
      }
    } else {
      const value = e.target.value;
      const name = e.target.name;
      console.log("--------------------=", name, value);
      // let totalnet = totalValues.totalCost?.toString()?.replaceAll(",", "");
      let totalnet = masterData.amount?.toString()?.replaceAll(",", "");
      totalnet = parseFloat(totalnet) > 0 ? parseFloat(totalnet) : 0;

      formValues[index][name] = value;

      if (name === "commissionAmount" && totalnet) {
        formValues[index]["commissionPersent"] = parseFloat(
          (parseFloat(
            formValues[index]["commissionAmount"]
              ?.toString()
              ?.replaceAll(",", "")
          ) /
            totalnet) *
            100
        );
      } else if (name === "commissionPersent" && totalnet) {
        formValues[index]["commissionAmount"] = parseFloat(
          (parseFloat(formValues[index]["commissionPersent"]) / 100) * totalnet
        );
      }
    }
    setCommRecDetailArray({
      ...commRecDetailArray,
      formValues,
    });
  };
  const propTypeLov = () => {
    axios
      .post(
        `${baseurl}/realEState/getPropType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;
        setPropTypLov({
          ...propTypLov,
          propTypLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const propCatLov = () => {
    axios
      .post(
        `${baseurl}/realEState/getPropCat`,
        {
          companyId: companyId,
          username: username,
          // brId: this.props?.location.state?.row_branch_id,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let responseData = res.data.data;

        setCategoryLov({
          ...categoryLov,
          categoryLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const propSectLov = (id) => {
    axios
      .post(
        `${baseurl}/RealEstate/getSector`,
        {
          companyId: companyId,
          username: username,
          id,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let responseData = res.data.data;
        setSectorLov({
          ...sectorLov,
          sectorOptions: responseData,
        });
        // setMasterData({ ...masterData, sectorId: null });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const propsocitLov = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getAllSocietyLov`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;
        setSocietyLov({
          ...societyLov,
          societyLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const partyLovFunc = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getParty`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;
        setPartyLov({
          ...partyLov,
          partyLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getTermsTypes = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getTermsType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;
        setTermsTypeLov({
          ...termsTypeLov,
          termsTypeOptions: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getPeriods = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getPeriod`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;
        setPeriodsLov({
          ...periodsLov,
          periodsOptions: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const propSizLov = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getPropertSizeMtLov`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;
        setPropSizeLov({
          ...propSizeLov,
          propSizeLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleChangeMapHideShow = (e) => {
    setDivcontainer(!divcontainer);
  };
  const handleChangeMapHideShow2 = (e) => {
    setDivcontainer2(!divcontainer2);
  };
  const handleChangeMapHideShow3 = (e) => {
    setDivcontainer3(!divcontainer3);
  };
  let propsData = props.location.state;

  useEffect(() => {
    const funCall = async (value) => {
      const openModalCheck = await asyncRollCheck(value);
    };

    let id = propsData?.id;
    // if (propsData?.updateCheck === 1 || propsData?.updateCheck === 2) {
    //   getDataWithId(id, propsData?.updateCheck);
    // } else {
    //   // dealMaxNumber();
    //   checkDateOfYear(data.depDate);
    // }

    if (propsData?.updateCheck === 1) {
      funCall(0);
      getDataWithId(id, propsData?.updateCheck);
    } else if (propsData?.updateCheck === 2) {
      funCall(2);
      getDataWithId(id, propsData?.updateCheck);
      checkDateOfYear(masterData.dealDate);
    } else {
      funCall(1);
      checkDateOfYear(masterData.dealDate);
    }
    propCatLov();
    propsocitLov();
    propTypeLov();
    propSizLov();
    partyLovFunc();
    getTermsTypes();
    getPeriods();
    // if (propsData?.updateCheck !== 1) getIpCountry();
  }, []);
  const asyncRollCheck = async (value) => {
    let pathname = "/directDeal";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  const getIpCountry = async () => {
    let { userIp, userCountry } = await getUserIp();
    setIpCountry({ userIp, userCountry });
  };
  const checkDateOfYear = async (e) => {
    let dealDate;
    let byDefault;
    if (e === "did") {
      byDefault = "didMount";
      dealDate = masterData.dealDate;
    } else {
      byDefault = "";
      dealDate = e;
    }
    const tableName = "re_direct_deal_mt";
    const invoiceType = "";
    const invBookId = 40;
    const dateColumn = "deal_date";
    const documentNo = "deal_no";
    var date = moment(dealDate).format("YYYY-MM-DD");

    let closeDate = await CheckClosingYearD(
      date,
      tableName,
      invoiceType,
      invBookId,
      dateColumn,
      documentNo,
      byDefault
    );
    let dealNo = closeDate[1];

    if (closeDate[0] === true) {
      setMasterData({
        ...masterData,
        dealDate: "",
        dealNo: "",
      });
    } else if (closeDate[0] === false) {
      setMasterData({
        ...masterData,
        dealDate: dealDate,
        dealNo: dealNo,
      });
    } else {
      setMasterData({
        ...masterData,
        dealDate: "",
        dealNo: "",
      });
    }
  };
  const handleCheckBoxes = (e) => {
    // let formValues = data.formValues;
    // console.log("////", e);
    const { checkboxes, remarks } = e;
    console.log("////", checkboxes);
    console.log("////", remarks);

    // masterData.checkboxes = checkboxes;
    // masterData.remarks = remarks;
    setMasterData({
      ...masterData,
      checkboxes: checkboxes,
      remarks: remarks,
      isOpenPropModel: !masterData.isOpenPropModel,
    });
  };
  const getDataWithId = (id, updateCheck) => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/realEState/getDirectDealWithId`,
        { id, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data;
        let resDataMt = response.masterRecord[0];
        let resDataDet = response.masterRecord;
        let termsRecord = response.termsRecord;
        let commissionRecRecord = response.commRecRecord;
        let commissionPayRecord = response.commPayRecord;

        // 0 = add, 1 = disabled, 2 = update
        if (updateCheck === 1) {
          setDisabledState(true);
        }

        const {
          deal_no,
          our_party_id,
          deal_date,
          deal_desc,
          our_party_name,
          society_id,
          society_name,
          sector_id,
          sector_name,
          Owner_name,
          owner_cell_no,
          owner_Addr_det,
          owner_nic_no,
          buyer_name,
          buyer_Addr_det,
          buyer_cell_no,
          buyer_nic_no,
          prop_type_id,
          prop_type_name,
          prop_catag_id,
          prop_catag_name,
          size_id,
          prop_size_desc,
          prop_no,
          amount,
          remarks,
          all_id,
          direct_deal_id,
          journal_id,
        } = resDataMt;
        let prop_deal_date = convertToYmdDateFormart(deal_date, 1);
        let checkboxes = all_id;
        let checkboxesArray = null;
        let featurelabels = all_id;
        let featurelabelsArray = "[";
        if (checkboxes) {
          checkboxesArray = "[";
          featurelabelsArray = "[";
          checkboxesArray = checkboxesArray + checkboxes + "]";
          checkboxesArray = checkboxesArray.replace(/'\'/g, "");
          checkboxesArray = JSON.parse(checkboxesArray);

          featurelabelsArray = featurelabelsArray + featurelabels + "]";
          featurelabelsArray = featurelabelsArray.replace(/'\'/g, "");

          featurelabelsArray = JSON.parse(featurelabelsArray);
        } else {
          featurelabelsArray = [];
        }

        setMasterData({
          ...masterData,
          dealNo: deal_no,
          dealDate: prop_deal_date,
          partyName: checkNullObject(our_party_id, our_party_name),
          dealDescription: deal_desc,
          societyId: checkNullObject(society_id, society_name),
          sectorId: checkNullObject(sector_id, sector_name),
          ownerName: Owner_name,
          ownerAddress: owner_Addr_det,
          ownerPhone: owner_cell_no,
          ownerNic: owner_nic_no,
          buyerName: buyer_name,
          buyerAddress: buyer_Addr_det,
          buyerPhone: buyer_cell_no,
          buyerNic: buyer_nic_no,
          typeId: checkNullObject(prop_type_id, prop_type_name),
          categoryId: checkNullObject(prop_catag_id, prop_catag_name),
          sizeId: checkNullObject(size_id, prop_size_desc),
          propNo: prop_no,
          amount: amount,
          journalId: journal_id,
          remarks: remarks,
          updateCheck,
          id: direct_deal_id,
          checkboxes: checkboxesArray,
        });
        if (society_id) propSectLov(society_id);

        let termsFormValues = [];
        if (termsRecord.length > 0) {
          for (let index = 0; index < termsRecord.length; index++) {
            const {
              term_type_id,
              term_type_desc,
              amount,
              comm_perc,
              period_type_id,
              PERIOD_TYPE_DESC,
              no_of_periods,
              remarks,
            } = termsRecord[index];
            termsFormValues.push({
              termsType: checkNullObject(term_type_id, term_type_desc),
              termsAmount: amount,
              termsPersent: comm_perc,
              termsPeriod: checkNullObject(period_type_id, PERIOD_TYPE_DESC),
              termsNo: no_of_periods,
              termsRemarks: remarks,
            });
          }
          setTerms({ ...terms, formValues: termsFormValues });
        } else {
          setTerms({ ...terms, formValues: [{}] });
        }
        let commisionRecFormValues = [];
        if (commissionRecRecord.length > 0) {
          for (let index = 0; index < commissionRecRecord.length; index++) {
            const { party_id, Party_Name, comm_amt, comm_perc, remarks } =
              commissionRecRecord[index];
            commisionRecFormValues.push({
              commissionParty: checkNullObject(party_id, Party_Name),
              commissionAmount: comm_amt,
              commissionPersent: comm_perc,
              commissionRemarks: remarks,
            });
          }
          setCommRecDetailArray({
            ...commRecDetailArray,
            formValues: commisionRecFormValues,
          });
        } else {
          setCommRecDetailArray({
            ...commRecDetailArray,
            formValues: [{}],
          });
          setDivcontainer2(false);
        }

        let commisionPayFormValues = [];
        if (commissionPayRecord.length > 0) {
          for (let index = 0; index < commissionPayRecord.length; index++) {
            const { party_id, Party_Name, comm_amt, comm_perc, remarks } =
              commissionPayRecord[index];
            commisionPayFormValues.push({
              commissionPayParty: checkNullObject(party_id, Party_Name),
              commissionPayAmount: comm_amt,
              commissionPayPersent: comm_perc,
              commissionPayRemarks: remarks,
            });
          }
          setData({
            ...data,
            formValues: commisionPayFormValues,
          });
        } else {
          setData({
            ...data,
            formValues: [{}],
          });
          setDivcontainer(false);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponce(false);
      });
  };
  const dealMaxNumber = () => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/realEState/getDealMaxNo`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data[0];
        let dealNo = response?.max_deal_no;
        setMasterData({ ...masterData, dealNo });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponce(false);
      });
  };
  const getUserIp = async function () {
    let res = await GetIp();
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };

  const handleSubmit = async (event) => {
    console.log("submit", masterData, data, terms, commRecDetailArray);
    setLoadingResponce(true);

    event.preventDefault();

    var companyId = localStorage.getItem("companyId");

    let { userIp, userCountry } = await getUserIp;
    let checkOneCommRequried = true;
    let partyId = masterData?.partyName?.id;
    let societyId = masterData?.societyId?.id;
    let sectorId = masterData?.sectorId?.id;
    let typeId = masterData?.typeId?.id;
    let categoryId = masterData?.categoryId?.id;
    let sizeId = masterData?.sizeId?.id;

    let totalnet = masterData.amount?.toString()?.replaceAll(",", "");
    totalnet = Number(totalnet) > 0 ? Number(totalnet) : 0;

    let validateCheck = true;
    let sumOfPersent = 0;
    console.log("pehlaaaaaaaaaaaa", sumOfPersent);
    let termsPercentageExceed = 0;
    // 0 ka mtlb he terms and commission 2no show na ho
    // 1 k mtlb he terms on he
    // 2 ka mtlb he commission on he

    // let midManId = masterData?.midManId?.id ? masterData?.midManId?.id : null;

    let checkRequired = true;
    console.log(terms.formValues?.[0]);
    if (
      terms.formValues?.[0]?.["termsType"]?.id ||
      terms.formValues?.[0]?.["termsAmount"] ||
      terms.formValues?.[0]?.["termsPersent"] ||
      terms.formValues?.[0]?.["termsPeriod"]?.id ||
      terms.formValues?.[0]?.["termsNo"] ||
      terms.formValues?.[0]?.["termsRemarks"]
    ) {
      for (let index = 0; index < terms.formValues.length; index++) {
        const element = terms.formValues[index];
        if (!element?.termsType?.id || !element?.termsPeriod?.id) {
          checkRequired = false;
          break;
        }
      }
    }

    if (
      (commRecDetailArray.formValues?.[0]?.["commissionParty"]?.id ||
        commRecDetailArray.formValues?.[0]?.["commissionAmount"] ||
        commRecDetailArray.formValues?.[0]?.["commissionPersent"] ||
        commRecDetailArray.formValues?.[0]?.["commissionRemarks"]) &&
      checkRequired
    ) {
      for (
        let index = 0;
        index < commRecDetailArray.formValues.length;
        index++
      ) {
        const element = commRecDetailArray.formValues[index];
        if (!element?.commissionParty?.id) {
          checkRequired = false;
          break;
        }
      }
    }

    console.log(
      "Idddddddddddddds",
      validateCheck,
      partyId,
      societyId,
      sectorId,
      checkRequired
    );
    if (checkRequired) {
      // const terms = terms.formValues;
      for (let i = 0; i < terms.formValues.length; i++) {
        sumOfPersent += Number(
          terms.formValues[i]?.termsPersent?.toString()?.replaceAll(",", "")
        );
        console.log("sumOfPersent :>> ", sumOfPersent, sumOfPersent > 100);
        if (sumOfPersent > 100) {
          validateCheck = false;
          checkRequired = false;
          termsPercentageExceed = 1;

          break;
        }
      }
    }
    if (
      checkRequired &&
      commRecDetailArray.formValues[0].commissionParty != null
    ) {
      sumOfPersent = 0;
      // let formValues = commRecDetailArray.formValues;
      for (let i = 0; i < commRecDetailArray.formValues.length; i++) {
        checkOneCommRequried = false;
        sumOfPersent += Number(
          commRecDetailArray.formValues[i]?.commissionPersent
            ?.toString()
            ?.replaceAll(",", "")
        );
        console.log("sumOfPersent :>> ", sumOfPersent, sumOfPersent > 100);
        if (sumOfPersent > 100) {
          termsPercentageExceed = 2;
          validateCheck = false;
          checkRequired = false;
          break;
        }
      }
    }

    if (checkRequired && data.formValues[0].commissionPayParty != null) {
      sumOfPersent = 0;
      // let formValues = commRecDetailArray.formValues;
      for (let i = 0; i < data.formValues.length; i++) {
        checkOneCommRequried = false;
        sumOfPersent += Number(
          data.formValues[i]?.commissionPayPersent
            ?.toString()
            ?.replaceAll(",", "")
        );
        console.log("sumOfPersent :>> ", sumOfPersent, sumOfPersent > 100);
        if (sumOfPersent > 100) {
          termsPercentageExceed = 3;
          validateCheck = false;
          break;
        }
      }
    }

    console.log("data.formValues", data.formValues[0].commissionPayAmount);
    if (
      validateCheck &&
      partyId &&
      societyId &&
      sectorId &&
      typeId &&
      categoryId &&
      sizeId &&
      checkRequired
    ) {
      console.log(
        "commRecDetailArray.formValues[0]",
        commRecDetailArray.formValues[0]
      );
      console.log(
        "commRecDetailArray.formValues[0].commissionParty",
        commRecDetailArray.formValues[0].commissionParty
      );
      console.log("data.formValues[0]", data.formValues[0]);
      console.log(
        "data.formValues[0].commissionPayParty",
        data.formValues[0].commissionPayParty
      );
      if (checkOneCommRequried) {
        swal({
          title: "Commission not found",
          text: "Atleast 1 type of commission should be considered",
          icon: "error",
        });
        setLoadingResponce(false);
      } else {
        let dealDate = convertToYmdDateFormart(masterData.dealDate);
        // let targetDate = convertToYmdDateFormart(masterData.targetDate);
        // return;
        console.log("cheeeecccck", terms.formValues[0]?.partyLov);
        console.log("cheeeecccck", terms.formValues[0]);
        console.log("cheeeecccck", commRecDetailArray.formValues[0]?.partyLov);
        console.log("cheeeecccck", commRecDetailArray.formValues[0]);
        console.log("cheeeecccck", data.formValues[0]?.partyLov);
        console.log("cheeeecccck", data.formValues > 0);
        console.log(
          "cheeeecccck",
          Object.keys(data.formValues[0]).length === 0
        );
        if (masterData.id > 0) {
          axios
            .post(
              `${baseurl}/realEState/updateDirectDeal`,
              {
                id: masterData?.id,
                companyId,
                purchse_No: masterData.dealNo,
                deal_date: dealDate,
                our_party_id: partyId,
                deal_desc: masterData.dealDescription,
                society_Id: societyId,
                sector_id: sectorId,
                Owner_name: masterData.ownerName,
                owner_Addr_det: masterData.ownerAddress,
                owner_cell_no: masterData.ownerPhone,
                owner_nic_no: masterData.ownerNic,
                buyer_name: masterData.buyerName,
                buyer_Addr_det: masterData.buyerAddress,
                buyer_cell_no: masterData.buyerPhone,
                buyer_nic_no: masterData.buyerNic,
                prop_type_id: typeId,
                prop_catag_id: categoryId,
                size_id: sizeId,
                prop_no: masterData.propNo,
                amount: totalnet,
                checkboxes: masterData.checkboxes,
                remarks: masterData.remarks,
                // mast_Remarks: masterData.remarks ? masterData.remarks : "",
                termsArray:
                  Object.keys(terms.formValues[0]).length === 0 ||
                  terms.formValues[0]?.partyLov === null ||
                  terms.formValues[0]?.commissionPayParty === null
                    ? null
                    : terms.formValues,
                commRecDetailArray:
                  Object.keys(commRecDetailArray.formValues[0]).length === 0 ||
                  commRecDetailArray.formValues[0]?.partyLov === null ||
                  commRecDetailArray.formValues[0]?.commissionParty === null
                    ? null
                    : commRecDetailArray.formValues,
                commPayDetailArray:
                  Object.keys(data.formValues[0]).length === 0 ||
                  data.formValues[0]?.partyLov === null ||
                  data.formValues[0]?.commissionPayParty === null
                    ? null
                    : data.formValues,
                username: username,
                userIp,
                userCountry,
              },
              {
                headers: {
                  authorization: token,
                },
              }
            )
            .then(function (response) {
              console.log("REc", commRecDetailArray.formValues);
              console.log(
                "update",
                commRecDetailArray.formValues[0]?.commissionAmount
              );
              console.log("Pay", data.formValues[0]);
              // let RecColapse =
              //   commRecDetailArray.formValues[0]?.commissionAmount;
              // if (!RecColapse) {
              //   setDivcontainer2(true);
              // }
              // let payColapse = data.formValues[0]?.commissionPayParty;
              // if (!payColapse) {
              //   setDivcontainer(true);
              // }

              setLoadingResponce(false);
              if (response.data.duplicate === true) {
                swal({
                  title: "Duplicate Code is not Allowed",
                  text: "Duplicate Entry",
                  icon: "error",
                });
              } else {
                swal({
                  title: "Saved Successfully!",
                  text: "Direct Deal Updated",
                  icon: "success",
                }).then((value) => {
                  // toggleAddNew();
                  setMasterData({
                    ...masterData,
                    showJvBtn: true,
                  });
                  setDisabledState(true);
                  // props.history.push({
                  //   pathname: "/DealOverview",
                  // });
                });
              }
            })
            .catch(function (error) {
              console.log("erooor", error);

              swal({
                title: "Error",
                text: "Something went wrong, try to refresh the page and try again.",
                icon: "error",
              });
            })
            .finally(function () {
              setLoadingResponce(false);
            });
        } else {
          axios
            .post(
              `${baseurl}/realEState/addDirectDeal`,
              {
                companyId,
                purchse_No: masterData.dealNo,
                deal_date: dealDate,
                our_party_id: partyId,
                deal_desc: masterData.dealDescription,
                society_Id: societyId,
                sector_id: sectorId,
                Owner_name: masterData.ownerName,
                owner_Addr_det: masterData.ownerAddress,
                owner_cell_no: masterData.ownerPhone,
                owner_nic_no: masterData.ownerNic,
                buyer_name: masterData.buyerName,
                buyer_Addr_det: masterData.buyerAddress,
                buyer_cell_no: masterData.buyerPhone,
                buyer_nic_no: masterData.buyerNic,
                prop_type_id: typeId,
                prop_catag_id: categoryId,
                size_id: sizeId,
                prop_no: masterData.propNo,
                amount: totalnet,
                checkboxes: masterData.checkboxes,
                remarks: masterData.remarks,
                // mast_Remarks: masterData.remarks ? masterData.remarks : "",
                termsArray: terms.formValues ? terms.formValues : null,
                commRecDetailArray: commRecDetailArray.formValues
                  ? commRecDetailArray.formValues
                  : null,
                commPayDetailArray: data.formValues ? data.formValues : null,
                username: username,
                userIp: masterData.userIp,
                userCountry: masterData.userCountry,
              },
              {
                headers: {
                  authorization: token,
                },
              }
            )
            .then(function (response) {
              setLoadingResponce(false);
              if (response.data.duplicate === true) {
                swal({
                  title: "Duplicate Code is not Allowed",
                  text: "Duplicate Entry",
                  icon: "error",
                });
              } else {
                swal({
                  title: "Saved Successfully!",
                  text: "Direct Deal Added",
                  icon: "success",
                }).then((value) => {
                  setMasterData({
                    ...masterData,
                    dealNo: response.data.latestDocNo,
                    journalId: response.data.journalId,
                    id: response.data.id,
                    showJvBtn: true,
                  });
                  setDisabledState(true);
                });
              }
            })
            .catch(function (error) {
              console.log("erooor", error);
              // setLoadingResponce(false);

              swal({
                title: "Error",
                text: "Something went wrong, try to refresh the page and try again.",
                icon: "error",
              });
            })
            .finally(function () {
              setLoadingResponce(false);
            });
        }
        if (!data.formValues?.[0]?.commissionPayParty?.id)
          setDivcontainer(false);
        if (!commRecDetailArray.formValues?.[0]?.commissionParty?.id)
          setDivcontainer2(false);
      }
    } else {
      console.log("sumOfPersent11111", sumOfPersent);
      sumOfPersent > 100
        ? swal({
            title: "Percentage exceeded",
            text: `The ${
              termsPercentageExceed === 1
                ? "Terms"
                : termsPercentageExceed === 2
                ? "Commission Reciveable"
                : termsPercentageExceed === 3
                ? "Commission Payable"
                : 0
            }  percentage cannot exceed 100%.`,
            icon: "error",
          })
        : swal({
            title: "Invalid Entry",
            text: "Please enter all required fields",
            icon: "warning",
          });
      sumOfPersent = 0;
      termsPercentageExceed = 0;
      console.log("sumOfPersent2222222222222", sumOfPersent);

      setRequiredCheck(true);
      setLoadingResponce(false);
    }
  };
  const { isOpenPartyModel } = masterData;
  console.log("///", masterData.checkboxes);
  console.log("///", masterData.remarks);
  return (
    <>
      {loadingResponce === true ? (
        <ResponseLoader />
      ) : (
        <div>
          <Row className="Creative-Invoice-header-styling">
            <Col xs="6" className="card-header-Creative-Invoice">
              <>
                <strong>
                  <h4>
                    Direct Deal Form
                    {propsData === 1
                      ? " - (preview)"
                      : propsData === 2
                      ? " - (Update)"
                      : " - (Add)"}
                  </h4>
                </strong>
              </>
            </Col>
            <Col xs="6" className="card-header-Creative-Invoice">
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Link
                  to="/directDealOverview"
                  style={{
                    fontFamily: "Times New Roman",
                    fontWeight: "normal",
                    margin: "10px",
                  }}
                >
                  <u className="Back-to-Overview">Back to Overview</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-chevron-left mx-2 icon-color"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </Col>
          </Row>

          <Row className="rowStyling">
            <Col>
              <div className="row">
                <div className="col-md-12">
                  <Form name="simpleForm" onSubmit={handleSubmit}>
                    <div className="row">
                      {/* <div className="col-md-12">
                          <div className="row my-2" translate="no"></div>
                        </div> */}
                      <div
                        className="col-md-3"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Direct Deal No:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Input
                          type="number"
                          className="form-control"
                          name="DealNo"
                          id="DealNo"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.dealNo}
                          required
                          disabled
                        />
                      </div>
                      <div
                        className="col-md-3"
                        style={{ marginBottom: "12px" }}
                      ></div>
                      <ReactDatePicker
                        label="Date:"
                        className="col-xl-3"
                        isSelected={masterData.dealDate}
                        onChange={(e) => {
                          setMasterData({
                            ...masterData,
                            dealDate: e,
                            // targetDate: null,
                          });
                          checkDateOfYear(e);
                        }}
                        isDisabled={disabledState}
                      />
                      <div
                        translate="no"
                        className="col-md-4"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Party Name:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Select
                          // key={JSON.stringify(element.itemType)}
                          // value={element.itemType}
                          // onChange={(e) => selectItemTypeEvent(e, index)}
                          options={partyLov.partyLov}
                          onChange={(e) => {
                            masterInputEvent(e, "partyName");
                            // await checkDuplicatePartySelection();
                          }}
                          value={masterData.partyName}
                          required
                          id="partyName"
                          name="partyName"
                          isClearable
                          placeholder={"-- Select --"}
                          isDisabled={disabledState}
                        />

                        {!masterData.partyName?.id && requiredCheck ? (
                          <div style={{ color: "red" }}>
                            <p>Please Select Company Name</p>
                          </div>
                        ) : null}
                      </div>
                      <div
                        className="col-md-2 col-md-1 "
                        style={{ marginTop: "30px" }}
                      >
                        {/* <Link to="/AddPartyType"> */}
                        <Button
                          style={{
                            background: "#20a8d880",
                            color: "white",
                            width: "96px",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                          }}
                          className="btn-client-invoice  "
                          size="sm"
                          type="button"
                          onClick={addPartyToggle}
                          disabled={disabledState}
                        >
                          Add Party
                        </Button>
                        {/* </Link> */}
                      </div>
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Deal Description:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="dealDescription"
                          id="dealDescription"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.dealDescription}
                          required
                          disabled={disabledState}
                        />
                      </div>

                      <div
                        className="col-md-12 border"
                        style={{ marginBottom: "12px", textAlign: "center" }}
                      >
                        <h4>Owner Details</h4>
                      </div>
                      <div
                        className="col-md-12 "
                        style={{ marginBottom: "12px" }}
                      >
                        <div
                          className="row py-2"
                          style={{
                            // paddingLeft: "2px",
                            backgroundColor: "#ECEEFF",
                            borderRadius: "23px",
                          }}
                        >
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Name:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="ownerName"
                              id="ownerName"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.ownerName}
                              required
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Address:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="ownerAddress"
                              id="ownerAddress"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.ownerAddress}
                              required
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Phone:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="ownerPhone"
                              id="ownerPhone"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.ownerPhone}
                              required
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              NIC No:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="ownerNic"
                              id="ownerNic"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.ownerNic}
                              required
                              disabled={disabledState}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-12 border"
                        style={{ marginBottom: "12px", textAlign: "center" }}
                      >
                        {" "}
                        <h4>Buyer Details</h4>
                      </div>
                      <div
                        className="col-md-12"
                        style={{ marginBottom: "12px" }}
                      >
                        <div
                          className="row py-2"
                          style={{
                            // paddingLeft: "2px",
                            backgroundColor: "#ECEEFF",
                            borderRadius: "23px",
                          }}
                        >
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Name:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="buyerName"
                              id="buyerName"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.buyerName}
                              required
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Address:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="buyerAddress"
                              id="buyerAddress"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.buyerAddress}
                              required
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Phone:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="buyerPhone"
                              id="buyerPhone"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.buyerPhone}
                              required
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              NIC No:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="buyerNic"
                              id="buyerNic"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.buyerNic}
                              required
                              disabled={disabledState}
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Society:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>

                            <Select
                              // key={JSON.stringify(element.itemType)}
                              // value={element.itemType}
                              // onChange={(e) => selectItemTypeEvent(e, index)}
                              options={societyLov.societyLov}
                              onChange={(e) => masterInputEvent(e, "societyId")}
                              value={masterData.societyId}
                              required
                              id="societyId"
                              name="societyId"
                              isClearable
                              placeholder={"-- Select --"}
                              isDisabled={disabledState}
                            />

                            {!masterData.societyId?.id && requiredCheck ? (
                              <div style={{ color: "red" }}>
                                <p>Please Select Society</p>
                              </div>
                            ) : null}
                          </div>
                          <div
                            className="col-md-2 col-md-1 "
                            style={{ marginTop: "30px" }}
                          >
                            <Button
                              style={{
                                background: "#20a8d880",
                                color: "white",
                                width: "96px",
                                whiteSpace: "nowrap",
                                textAlign: "center",
                              }}
                              className="btn-client-invoice  "
                              size="sm"
                              onClick={() => setShowFormOnBtn(2)}
                              disabled={disabledState}
                            >
                              Add Society
                            </Button>
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Sector/Phase:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>

                            <Select
                              // key={JSON.stringify(element.itemType)}
                              // value={element.itemType}
                              // onChange={(e) => selectItemTypeEvent(e, index)}
                              options={sectorLov.sectorOptions}
                              onChange={(e) => masterInputEvent(e, "sectorId")}
                              value={masterData.sectorId}
                              required
                              isDisabled={
                                !masterData.societyId?.id || disabledState
                              }
                              id="sectorId"
                              name="sectorId"
                              isClearable
                              placeholder={"-- Select --"}
                            />

                            {!masterData.sectorId?.id && requiredCheck ? (
                              <div style={{ color: "red" }}>
                                <p>Please Select Sector/Phase</p>
                              </div>
                            ) : null}
                          </div>
                          <div
                            className="col-md-2 col-md-1 "
                            style={{ marginTop: "30px" }}
                          >
                            <Button
                              style={{
                                background: "#20a8d880",
                                color: "white",
                                width: "96px",
                                whiteSpace: "nowrap",
                                textAlign: "center",
                              }}
                              className="btn-client-invoice  "
                              size="sm"
                              onClick={() => setShowFormOnBtn(3)}
                              disabled={disabledState}
                            >
                              Add Sector
                            </Button>
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Type:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>

                            <Select
                              // key={JSON.stringify(element.itemType)}
                              value={masterData.typeId}
                              onChange={(e) => {
                                masterInputEvent(e, "type");
                              }}
                              options={propTypLov.propTypLov}
                              id="type"
                              name="type"
                              isClearable
                              placeholder={"-- Select --"}
                              isDisabled={disabledState}
                            />

                            {requiredCheck && !masterData.typeId?.id ? (
                              <div style={{ color: "red" }}>
                                <p>Please Select Property Type</p>
                              </div>
                            ) : null}
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Category:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>

                            <Select
                              // key={JSON.stringify(element.itemType)}
                              value={masterData.categoryId}
                              onChange={(e) => {
                                masterInputEvent(e, "category");
                              }}
                              options={categoryLov.categoryLov}
                              id="category"
                              name="category"
                              isClearable
                              placeholder={"-- Select --"}
                              isDisabled={disabledState}
                            />

                            {requiredCheck && !masterData.categoryId?.id ? (
                              <div style={{ color: "red" }}>
                                <p>Please Select Property Category</p>
                              </div>
                            ) : null}
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Size:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>

                            <Select
                              // key={JSON.stringify(element.itemType)}
                              value={masterData.sizeId}
                              onChange={(e) => {
                                masterInputEvent(e, "size");
                              }}
                              options={propSizeLov.propSizeLov}
                              id="size"
                              name="size"
                              isClearable
                              placeholder={"-- Select --"}
                              isDisabled={disabledState}
                            />

                            {requiredCheck && !masterData.sizeId?.id ? (
                              <div style={{ color: "red" }}>
                                <p>Please Select Property Size</p>
                              </div>
                            ) : null}
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Property No:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="propNo"
                              id="propNo"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.propNo}
                              disabled={disabledState}
                              required
                            />
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Amount:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>

                            <NumberFormat
                              name="amount"
                              className="form-control"
                              style={{ textAlign: "right" }}
                              thousandSeparator={true}
                              value={masterData.amount || ""}
                              // placeholder="00"
                              decimalScale={0}
                              required
                              fixedDecimalScale
                              // onChange={(e) => masterInputEvent(e)}
                              onChange={(e) => {
                                if (
                                  !terms.formValues[0]?.termsAmount &&
                                  !commRecDetailArray.formValues[0]
                                    ?.commissionAmount &&
                                  !data.formValues[0]?.commissionPayAmount &&
                                  terms.formValues?.length === 1 &&
                                  commRecDetailArray.formValues?.length === 1 &&
                                  data.formValues?.length === 1
                                ) {
                                  masterInputEvent(e);
                                } else {
                                  swal({
                                    icon: "warning",
                                    label: "Invalid Operation",
                                    text: "First delete the Terms and Commission data!",
                                  });
                                }
                              }}
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-2 col-md-1 "
                            style={{ marginTop: "30px" }}
                          >
                            <Button
                              style={{
                                background: "#20a8d880",
                                color: "white",
                                width: "96px",
                                whiteSpace: "nowrap",
                                textAlign: "center",
                              }}
                              className="btn-client-invoice  "
                              size="sm"
                              // onClick={() => setShowFormOnBtn(2)}
                              // disabled={disabledState}
                              disabled
                            >
                              Map
                            </Button>
                          </div>
                          <div
                            className="col-md-2 col-md-1 "
                            style={{ marginTop: "30px" }}
                          >
                            <Button
                              type="button"
                              size="sm"
                              className="btn btn-danger mx-2"
                              onClick={() => {
                                setMasterData({
                                  ...masterData,
                                  isOpenPropModel: !masterData.isOpenPropModel,
                                });
                              }}
                              // disabled={disabledState}
                              title={dynamicCurrencyFormator({
                                // cell: element.totalCost,
                                field: 1,
                              })}
                            >
                              Info
                            </Button>
                          </div>
                          <div className="col-md-3 pt-4 mt-1 ">
                            {masterData.checkboxes?.map((checkbox) => (
                              <span
                                className={`btn btn-sm btn-${checkbox?.color} mx-1 rounded-pill `}
                              >
                                {checkbox?.shortDesc}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-12 border-bottom my-2">
                          <h3>Terms </h3>
                        </div> */}
                      <div className="col-md-12 border-bottom my-2">
                        <Row className="pt-1">
                          <Col xs="6">
                            <>
                              <h3>Terms </h3>
                            </>
                          </Col>
                          <Col xs="6">
                            <div
                              style={{
                                textAlign: "right",
                              }}
                            >
                              <AppSwitch
                                className={"mx-1"}
                                onClick={handleChangeMapHideShow3}
                                variant="pill"
                                color="primary"
                                label
                                checked={divcontainer3}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <div className="row mx-2 my-3 p-2 InfoBox  ">
                        {divcontainer3 ? (
                          <>
                            {terms.formValues.map((element, index) => (
                              <div className="div my-1" key={index}>
                                <div className=" ">
                                  <div className="row pl-3">
                                    <div className="col-md-2  ">
                                      <Label>
                                        Type :
                                        <span className="text-danger">*</span>
                                      </Label>

                                      <Select
                                        value={element.termsType || ""}
                                        onChange={(e) =>
                                          inputEvent2(e, index, "termsType")
                                        }
                                        options={termsTypeLov.termsTypeOptions}
                                        // autoFocus
                                        required
                                        isClearable
                                        name="termsType"
                                        placeholder={"-- Select --"}
                                        isDisabled={disabledState}
                                      />

                                      {!element.termsType?.id &&
                                      requiredCheck &&
                                      (element.termsAmount ||
                                        element.termsPersent ||
                                        element.termsPeriod?.id ||
                                        element.termsNo ||
                                        element.termsRemarks) ? (
                                        <span className="text-danger">
                                          <p>Please Select Type</p>
                                        </span>
                                      ) : null}
                                    </div>

                                    <div className="col-md-2">
                                      <Label>
                                        Amount :
                                        <span className="text-danger">*</span>
                                      </Label>

                                      <NumberFormat
                                        name="termsAmount"
                                        className="form-control"
                                        style={{ textAlign: "right" }}
                                        thousandSeparator={true}
                                        value={element.termsAmount || ""}
                                        placeholder="00"
                                        decimalScale={0}
                                        required={
                                          element.termsType?.id ||
                                          // element.termsAmount ||
                                          element.termsPersent ||
                                          element.termsPeriod?.id ||
                                          element.termsNo ||
                                          element.termsRemarks
                                        }
                                        fixedDecimalScale
                                        onChange={(e) => inputEvent2(e, index)}
                                        disabled={disabledState}
                                      />
                                      <span style={{ color: "Red" }}>
                                        {element.termsAmountError}
                                      </span>
                                    </div>
                                    <div className="col-md-2 col-lg-1">
                                      <Label>
                                        %:{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <NumberFormat
                                        name="termsPersent"
                                        style={{ textAlign: "right" }}
                                        className="form-control"
                                        value={element.termsPersent || ""}
                                        disabled={disabledState}
                                        required={
                                          element.termsType?.id ||
                                          element.termsAmount ||
                                          // element.termsPersent ||
                                          element.termsPeriod?.id ||
                                          element.termsNo ||
                                          element.termsRemarks
                                        }
                                        fixedDecimalScale
                                        decimalScale={0}
                                        placeholder="0.00"
                                        onChange={(e) => inputEvent2(e, index)}
                                      />
                                      <br />
                                      <span style={{ color: "Red" }}>
                                        {element.termsPersentError}
                                      </span>
                                    </div>
                                    <div className="col-md-3 col-lg-2">
                                      <Label>
                                        Period:{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Select
                                        value={element.termsPeriod || ""}
                                        onChange={(e) =>
                                          inputEvent2(e, index, "termsPeriod")
                                        }
                                        options={periodsLov.periodsOptions}
                                        // autoFocus
                                        isRequired={true}
                                        isClearable
                                        name="termsPeriod"
                                        placeholder={"-- Select --"}
                                        isDisabled={disabledState}
                                      />
                                      {!element.termsPeriod?.id &&
                                      requiredCheck &&
                                      (element.termsType?.id ||
                                        element.termsAmount ||
                                        element.termsPersent ||
                                        element.termsNo ||
                                        element.termsRemarks) ? (
                                        <span className="text-danger">
                                          <p>Please Select Type</p>
                                        </span>
                                      ) : null}
                                    </div>
                                    <div className="col-md-2 col-lg-1">
                                      <Label>
                                        No :{" "}
                                        <span className="text-danger">*</span>
                                      </Label>

                                      <Input
                                        name="termsNo"
                                        className="form-control"
                                        style={{ textAlign: "right" }}
                                        disabled={disabledState}
                                        value={element.termsNo || ""}
                                        placeholder="00"
                                        required={
                                          element.termsType?.id ||
                                          element.termsAmount ||
                                          element.termsPersent ||
                                          element.termsPeriod?.id ||
                                          // element.termsNo ||
                                          element.termsRemarks
                                        }
                                        onChange={(e) => inputEvent2(e, index)}
                                      />
                                    </div>

                                    <div className="col-md-3">
                                      <Label style={{ fontWeight: "bold" }}>
                                        Remarks:
                                      </Label>
                                      <Input
                                        rows="1"
                                        type="textarea"
                                        id="termsRemarks"
                                        name="termsRemarks"
                                        className="form-control"
                                        disabled={disabledState}
                                        value={element.termsRemarks || ""}
                                        onChange={(e) => inputEvent2(e, index)}
                                      />
                                    </div>
                                    <div className="col-md-1 ml-n1 d-flex flex-row align-items-center">
                                      <>
                                        <Button
                                          className="btn btn-info text-white mx-2"
                                          type="button"
                                          size="sm"
                                          onClick={() => addTermsFormFields()}
                                          title="Add new row"
                                          disabled={disabledState}

                                          // title={tooltipText.addMulLineInv}
                                        >
                                          <i className="fa fa-plus "></i>
                                        </Button>

                                        <Button
                                          type="button"
                                          size="sm"
                                          className="btn btn-danger "
                                          onClick={() =>
                                            removeItemFormFields(index)
                                          }
                                          title="Delete row"
                                          disabled={disabledState}
                                        >
                                          <i className="fa fa-trash "></i>
                                        </Button>
                                      </>
                                    </div>
                                  </div>
                                </div>
                                {commRecDetailArray.formValues.length > 1 ? (
                                  <hr style={{}} />
                                ) : null}
                              </div>
                            ))}
                          </>
                        ) : null}
                      </div>
                      <div className="col-md-12 InvoiceLine-styling">
                        <Row className="commissionLineHeading pt-2">
                          <Col xs="6">
                            <div className="text-left ">
                              <h5>Commission Receivable</h5>
                            </div>
                          </Col>
                          <Col xs="6" className="d-flex flex-row-reverse">
                            <AppSwitch
                              className="mx-2 "
                              onClick={handleChangeMapHideShow2}
                              variant="pill"
                              size="lg"
                              // disabled={this.state.disabled ? "disabled" : ""}
                              color="primary"
                              checked={divcontainer2}
                            />
                            <p className=" mx-3 pt-1 ">
                              {" "}
                              {divcontainer2 ? "Hide " : "Show "}
                            </p>
                          </Col>
                        </Row>
                        <Collapse isOpen={true}>
                          {divcontainer2 ? (
                            <>
                              {commRecDetailArray.formValues.map(
                                (element, index) => (
                                  <div className="div my-1" key={index}>
                                    {/*  
                          <div className="InvoiceLine-styling ">
                              <div className="col-md-3 col-lg-2 InvoiceLineHeading">
                                <h6>Commission # {element.commissionLineNum}</h6>
                              </div>
                              </div>
                            */}

                                    <div className="row">
                                      <div className="col-md-3">
                                        <Label>
                                          Party:
                                          <span className="text-danger">*</span>
                                        </Label>

                                        <Select
                                          value={element?.commissionParty || ""}
                                          onChange={(e) =>
                                            inputEvent3(
                                              e,
                                              index,
                                              "commissionParty"
                                            )
                                          }
                                          options={partyLov.partyLov}
                                          // autoFocus
                                          required
                                          isClearable
                                          name="commissionParty"
                                          placeholder={"-- Select --"}
                                          isDisabled={disabledState}
                                        />
                                        {!element.commissionParty?.id &&
                                        requiredCheck &&
                                        (element.commissionPersent ||
                                          element.commissionAmount ||
                                          element.commissionRemarks) ? (
                                          <div style={{ color: "red" }}>
                                            <p>Please Select Party</p>
                                          </div>
                                        ) : null}
                                      </div>

                                      <div className="col-md-2">
                                        <Label>
                                          Amount :
                                          <span className="text-danger">*</span>
                                        </Label>

                                        <NumberFormat
                                          name="commissionAmount"
                                          className="form-control"
                                          style={{ textAlign: "right" }}
                                          thousandSeparator={true}
                                          value={element.commissionAmount || ""}
                                          placeholder="00"
                                          decimalScale={0}
                                          required={
                                            element.commissionParty?.id ||
                                            element.commissionPersent ||
                                            element.commissionRemarks
                                          }
                                          fixedDecimalScale
                                          onChange={(e) =>
                                            inputEvent3(e, index)
                                          }
                                          disabled={disabledState}
                                        />
                                        <span style={{ color: "Red" }}>
                                          {element.qtyError}
                                        </span>
                                      </div>
                                      <div className="col-md-3 col-lg-2">
                                        <Label>
                                          %:{" "}
                                          <span className="text-danger">*</span>
                                        </Label>

                                        <NumberFormat
                                          name="commissionPersent"
                                          style={{ textAlign: "right" }}
                                          className="form-control"
                                          value={
                                            element.commissionPersent || ""
                                          }
                                          disabled={disabledState}
                                          placeholder="0.00"
                                          fixedDecimalScale
                                          decimalScale={2}
                                          required={
                                            element.commissionParty?.id ||
                                            element.commissionAmount ||
                                            element.commissionRemarks
                                          }
                                          onChange={(e) =>
                                            inputEvent3(e, index)
                                          }
                                        />
                                      </div>

                                      <div className="col-md-3">
                                        <Label>Remarks:</Label>
                                        <Input
                                          rows="1"
                                          type="textarea"
                                          id="commissionRemarks"
                                          name="commissionRemarks"
                                          className="form-control"
                                          disabled={disabledState}
                                          value={
                                            element.commissionRemarks || ""
                                          }
                                          onChange={(e) =>
                                            inputEvent3(e, index)
                                          }
                                        />
                                      </div>
                                      <div
                                        className="col-md-2"
                                        style={{ marginTop: "0px" }}
                                      >
                                        <div>
                                          <Button
                                            className="btn btn-info text-white mx-2"
                                            type="button"
                                            size="sm"
                                            onClick={() => addFormFieldsItem2()}
                                            title="Add new row"
                                            disabled={disabledState}
                                            // title={tooltipText.addMulLineInv}
                                          >
                                            <i className="fa fa-plus "></i>
                                          </Button>

                                          <Button
                                            type="button"
                                            size="sm"
                                            className="btn btn-danger "
                                            onClick={() =>
                                              removeFormFieldsItem2(index)
                                            }
                                            title="Delete row"
                                            disabled={disabledState}
                                          >
                                            <i className="fa fa-trash "></i>
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                    {commRecDetailArray.formValues.length >
                                    1 ? (
                                      <hr style={{}} />
                                    ) : null}
                                  </div>
                                )
                              )}
                            </>
                          ) : null}
                        </Collapse>
                      </div>
                      <div
                        className="col-md-12 InvoiceLine-styling"
                        style={{ marginTop: "3%" }}
                      >
                        <Row className="commissionLineHeading pt-2">
                          <Col xs="6">
                            <div className="text-left">
                              <h5>Commission Payable</h5>
                            </div>
                          </Col>
                          <Col xs="6" className="d-flex flex-row-reverse">
                            <AppSwitch
                              className="mx-2 "
                              onClick={handleChangeMapHideShow}
                              variant="pill"
                              size="lg"
                              // disabled={this.state.disabled ? "disabled" : ""}
                              color="primary"
                              checked={divcontainer}
                            />
                            <p className=" mx-3 pt-1 ">
                              {" "}
                              {divcontainer ? "Hide " : "Show "}
                            </p>
                          </Col>
                        </Row>
                        <Collapse isOpen={true}>
                          {divcontainer ? (
                            <>
                              {data.formValues.map((element, index) => (
                                <div className="div my-1" key={index}>
                                  {/*  
                          <div className="InvoiceLine-styling ">
                              <div className="col-md-3 col-lg-2 InvoiceLineHeading">
                                <h6>Commission # {element.commissionLineNum}</h6>
                              </div>
                              </div>
                            */}

                                  <div className="row">
                                    <div className="col-md-3">
                                      <Label>
                                        Party:
                                        <span className="text-danger">*</span>
                                      </Label>

                                      <Select
                                        value={
                                          element?.commissionPayParty || ""
                                        }
                                        onChange={(e) =>
                                          inputEvent(
                                            e,
                                            index,
                                            "commissionPayParty"
                                          )
                                        }
                                        options={partyLov.partyLov}
                                        // autoFocus
                                        required
                                        isClearable
                                        name="commissionPayParty"
                                        placeholder={"-- Select --"}
                                        isDisabled={disabledState}
                                      />
                                      {!element.commissionPayParty?.id &&
                                      requiredCheck &&
                                      (element.commissionPayPersent ||
                                        element.commissionPayAmount ||
                                        element.commissionPayRemarks) ? (
                                        <div style={{ color: "red" }}>
                                          <p>Please Select Party</p>
                                        </div>
                                      ) : null}
                                    </div>
                                    <div className="col-md-2">
                                      <Label>
                                        Amount :
                                        <span className="text-danger">*</span>
                                      </Label>

                                      <NumberFormat
                                        name="commissionPayAmount"
                                        className="form-control"
                                        style={{ textAlign: "right" }}
                                        thousandSeparator={true}
                                        value={
                                          element.commissionPayAmount || ""
                                        }
                                        placeholder="00"
                                        decimalScale={0}
                                        required={
                                          element.commissionPayParty?.id ||
                                          element.commissionPayPersent ||
                                          element.commissionPayRemarks
                                        }
                                        fixedDecimalScale
                                        onChange={(e) => inputEvent(e, index)}
                                        disabled={disabledState}
                                      />
                                      <span style={{ color: "Red" }}>
                                        {element.qtyError}
                                      </span>
                                    </div>
                                    <div className="col-md-3 col-lg-2">
                                      <Label>
                                        %:{" "}
                                        <span className="text-danger">*</span>
                                      </Label>

                                      <NumberFormat
                                        name="commissionPayPersent"
                                        style={{ textAlign: "right" }}
                                        className="form-control"
                                        value={
                                          element.commissionPayPersent || ""
                                        }
                                        disabled={disabledState}
                                        placeholder="0.00"
                                        fixedDecimalScale
                                        decimalScale={2}
                                        required={
                                          element.commissionPayParty?.id ||
                                          element.commissionPayAmount ||
                                          element.commissionPayRemarks
                                        }
                                        onChange={(e) => inputEvent(e, index)}
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <Label>Remarks:</Label>
                                      <Input
                                        rows="1"
                                        type="textarea"
                                        id="commissionPayRemarks"
                                        name="commissionPayRemarks"
                                        className="form-control"
                                        disabled={disabledState}
                                        value={
                                          element.commissionPayRemarks || ""
                                        }
                                        onChange={(e) => inputEvent(e, index)}
                                      />
                                    </div>
                                    <div
                                      className="col-md-2"
                                      style={{ marginTop: "0px" }}
                                    >
                                      <div>
                                        <Button
                                          className="btn btn-info text-white mx-2"
                                          type="button"
                                          size="sm"
                                          onClick={() => addFormFieldsItem()}
                                          title="Add new row"
                                          disabled={disabledState}

                                          // title={tooltipText.addMulLineInv}
                                        >
                                          <i className="fa fa-plus"></i>
                                        </Button>

                                        <Button
                                          type="button"
                                          size="sm"
                                          className="btn btn-danger mx-2"
                                          onClick={() =>
                                            removeFormFieldsItem(index)
                                          }
                                          disabled={disabledState}
                                          title={tooltipText.remMulLineInv}
                                        >
                                          <i className="fa fa-trash"></i>
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                  {data.formValues.length > 1 ? (
                                    <hr style={{}} />
                                  ) : null}
                                </div>
                              ))}
                            </>
                          ) : null}
                        </Collapse>
                      </div>
                    </div>
                    <hr
                      style={{
                        border: "1px solid ",
                        marginBottom: "3vh",
                        marginTop: "3vh",
                        borderColor: "E4E5E6",
                      }}
                    />
                    <FormGroup>
                      <span>
                        <span>
                          <Link
                            disabled={loadingResponce ? true : false}
                            className="btn btn-danger mr-1"
                            size="sm"
                            to={{
                              pathname: "/newManualJournal",
                              goBackUrl: "/directDeal",
                              state: {
                                id: masterData?.journalId,
                                masterId: masterData?.id,
                                updateCheck: 1,
                                goBackLabel: "Direct Deal",
                              },
                            }}
                            hidden={
                              masterData?.showJvBtn
                                ? false
                                : !masterData.updateCheck ||
                                  masterData?.updateCheck == 2
                            }
                            // hidden={
                            //   !masterData.updateCheck || !masterData?.showJvBtn
                            // }
                          >
                            Show JV
                          </Link>
                        </span>

                        {/* <Button
                          size="md"
                          color="success"
                          className={[
                            "invoiceSubmitButton",
                            props?.location?.state?.updateCheck
                              ? null
                              : "hideShowDiv",
                          ]}
                          hidden={
                            masterData?.showJvBtn
                              ? false
                              : masterData?.updateCheck == 2
                          }
                          onClick={() => goBackFun()}
                        >
                          Print
                        </Button> */}

                        <span className="float-right">
                          <Link
                            to={{
                              pathname: "/directDealOverview",
                            }}
                            className="btn mr-1"
                            size="sm"
                          >
                            <Button>Cancel</Button>
                          </Link>
                          <Button
                            disabled={
                              loadingResponce ? true : false || disabledState
                            }
                            hidden={masterData.updateCheck === 1}
                            className="mr-1 invoiceSubmitButton "
                          >
                            {masterData.updateCheck === 2 ? "Update" : "Save"}{" "}
                            Changes
                          </Button>
                        </span>
                      </span>
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
          {isOpenPartyModel && (
            <>
              <Modal
                show={isOpenPartyModel}
                size="lg"
                onHide={addPartyToggle}
                backdrop="static"
              >
                <Modal.Body className=" mt-n4 px-1 mb-n3  ">
                  <AddPartyModel
                    closeModel={"closeModel"}
                    callBack={() => {
                      addPartyToggle();
                    }}
                  />
                </Modal.Body>
              </Modal>
            </>
          )}
          <br></br>
          <br></br>
          {/* model calls on Add New Button to input data for submit data */}
          {showFormOnBtn == 1 ? (
            <>
              <AddPartyType
                toggle={itemLoad}
                // EditData={this.state.row_id}
              />
            </>
          ) : showFormOnBtn == 2 ? (
            <>
              <AddSociety
                toggle={itemLoad}
                // EditData={this.state.row_id}
              />
            </>
          ) : showFormOnBtn == 3 ? (
            <>
              <AddSector
                toggle={itemLoad}
                // EditData={this.state.row_id}
              />
            </>
          ) : null}

          {masterData.isOpenPropModel && (
            <>
              <Modal
                show={masterData.isOpenPropModel}
                size="lg"
                onHide={addPropToggle}
                backdrop="static"
              >
                <Modal.Header className=" Creative-Invoice-header-styling">
                  <h5> Property</h5>
                </Modal.Header>
                <Modal.Body className="">
                  <PropFeature
                    toggle={addPropToggle}
                    sendDataBack={{
                      checkboxes: masterData.checkboxes,
                      remarks: masterData.remarks,
                      hideRemarks: true,
                      disableState: disabledState,
                      // id: formValues[checkIndex]?.dealPropId,
                    }}
                    callback={(e) => {
                      // console.log("////", e);
                      handleCheckBoxes(e);
                      // addPropToggle();
                    }}
                  />
                </Modal.Body>
              </Modal>
            </>
          )}
        </div>
      )}
    </>
  );
}
